import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { PlayArrow } from '@material-ui/icons';

import callApi from '../../../utils/callApi';
import { BLOGS_LIST } from '../../../constants/apiUrls/apiUrls';
import ArticleLink from '../../../components/blogComponents/ArticleLink';
import SubscribeCTAButtonV2 from '../../../components/GuestHomePageComponents/V2Components/SubscribeCTAButtonV2';

import styles from './css/GuestHomePageV2.module.css';


function BlogSection() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    callApi(BLOGS_LIST.replace('{page}', 0).replace('{size}', 4)).then(
      (data) => {
        setBlogs(data?.data?.blogs || []);
      }
    );
  }, []);

  return (
    <div className={classnames(styles.container, styles.anchorSection)}>
      <h2 className={styles.header}>Naked News Blog</h2>
      <div className={styles.blogGridContainer}>
        {blogs.map((blog) => (
          <div key={blog.id} className={styles.blogCard}>
            <ArticleLink article={blog} className={styles.blogTitle}>
              <img alt={blog.title} className={styles.blogImage} src={blog.imageUrl} />
              {blog?.isVideo && (
                <div className={styles.playIconBlog}>
                  <PlayArrow />
                </div>
              )}
              <p className={styles.blogTitleText}>{blog?.title}</p>
            </ArticleLink>
          </div>
        ))}
      </div>
      <div className={styles.buttonContainer}>
        <SubscribeCTAButtonV2 doNotHide={true} link="/news" title="VIEW ALL BLOGS" />
      </div>
    </div>
  );
}

export default observer(BlogSection);
